<template>
  <fragment v-if="campaignEditViewModel">
    <h5 class="section-title">{{ $t("CampaignEdit.Type.Caption") }}</h5>
    <b-radio v-model="selectedMetadataType" name="selectedMetadataType" v-for="channelMetadataType in channelMetadataTypesFiltered"
        :key="+channelMetadataType.Id" :native-value="+channelMetadataType.Id" @input="onSelectedMetadataTypeChange">
      {{ channelMetadataType.Title }}
    </b-radio>
  </fragment>
</template>

<script lang="ts">
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import { MultiselectItem } from "@/models/MultiselectItem";
import { CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import CampaignService from "@/services/CampaignService";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class TabType extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Action("setCampaignEditViewModel", { namespace }) setCampaignEditViewModel!: (campaignEditViewModel: CampaignEditViewModel) => Promise<void>;

  //#endregion Vuex getters and actions


  //#region Properties

  selectedMetadataType = ChannelType.None;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    if ((newCampaignEditViewModel.Campaign.Id > 0 && newCampaignEditViewModel.Campaign.IsMediaChannel
        || newCampaignEditViewModel.Campaign.Id === 0 && this.isMediaChannel)
        && newCampaignEditViewModel.CreatePhone) {
      this.selectedMetadataType = ChannelType.Phone;
      this.campaignEditViewModel.Campaign.ChannelType = this.selectedMetadataType;
      this.campaignEditViewModel.Campaign.ChannelTypeId = +this.selectedMetadataType;
    }
  }

  //#endregion Watchers


  //#region Getters

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    const mode: AvailableChannelMetadataTypesMode = this.campaignEditViewModel?.Campaign.Id > 0 && this.campaignEditViewModel?.Campaign.IsMediaChannel
        || this.campaignEditViewModel?.Campaign.Id === 0 && this.isMediaChannel
          ? AvailableChannelMetadataTypesMode.MediaCampaigns : AvailableChannelMetadataTypesMode.Campaigns;

      let metadataTypes = CampaignService.getChannelMetadataTypes(mode);

      const excludeTypes = [ChannelType.Outbrain.toString(), ChannelType.TikTokAds.toString(), ChannelType.TikTokLeads.toString()];

      metadataTypes = metadataTypes.filter(function (item) {
          return !excludeTypes.includes(item.Id);
	  })

	  return metadataTypes
  }

  get isMediaChannel(): boolean {
    if (this.$route.query.IsMediaChannel) {
      return this.$route.query.IsMediaChannel === "true";
    }
    return false;
  }

  //#endregion Getters


  //#region Handlers

  onSelectedMetadataTypeChange(metadataType: ChannelType) {
    this.campaignEditViewModel.Campaign.ChannelType = metadataType;
    this.campaignEditViewModel.Campaign.ChannelTypeId = +metadataType;
    this.setCampaignEditViewModel(this.campaignEditViewModel);
  }

  //#endregion Handlers
}
</script>

<style lang="scss" scoped>
.b-radio.radio {
  display: flex;
  margin-bottom: .5rem;
}
</style>
